export type CapacityChipState = "open" | "low" | "full";

export interface CapacityChip {
  state: CapacityChipState;
  remaining: number;
}

export const LOW_CAPACITY_FRACTION = 0.2;

export function capacityChip(
  limit: number | null | undefined,
  count: number | null | undefined
): CapacityChip | null {
  const configuredLimit = limit ?? 0;
  const unlimited = configuredLimit <= 0;
  if (unlimited) return null;

  const remaining = Math.max(0, configuredLimit - (count ?? 0));

  if (remaining === 0) return { state: "full", remaining };

  const runningLow = remaining / configuredLimit < LOW_CAPACITY_FRACTION;

  return { state: runningLow ? "low" : "open", remaining };
}

export function remainingLabel(
  remaining: number,
  singularNoun: string
): string {
  const noun = remaining === 1 ? singularNoun : `${singularNoun}s`;

  return `${remaining} ${noun} remaining`;
}
